
import { defineComponent } from 'vue'
import InputGroup from '@/components/layout/InputGroup.vue'
import { TMP_APPLY_EXPIRES } from '@/constants/backendConstants'

/**
 * 境界立会申請 エラー画面
 */
export default defineComponent({
  name: 'BoundaryAuthError',
  components: {
    InputGroup,
  },
  setup() {
    return {
      TMP_APPLY_EXPIRES,
    }
  },
})
